import Vue from 'vue';
import Vuex from 'vuex';
import productManage from './modules/productManage';
import productInsert from './modules/productInsert';
import discount from './modules/discount';
import Public from './modules/public';
import ship from './modules/ship';
import Login from './modules/Login';
import system from './modules/system';
import web from './modules/webSetting';
import epaper from './modules/epaper';
import member from './modules/memberManage';
import cart from './modules/cartManage';
import product from './modules/product';


Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    productManage,
    productInsert,
    discount,
    Public,
    ship,
    Login,
    system,
    web,
    epaper,
    member,
    cart,
    product
  },
});
